import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppBrowserModule } from './app/app.browser.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Use requestIdleCallback for better performance
function bootstrapApp() {
  platformBrowserDynamic()
    .bootstrapModule(AppBrowserModule)
    .catch(err => console.error('Bootstrap error:', err));
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(bootstrapApp);
} else {
  setTimeout(bootstrapApp, 0);
}